import React from "react";
import MFAManagement from "../components/MFAManagement";

const MFASettings = () => {
  return <MFAManagement />;
};

export default MFASettings;